import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	createAccountButton: {
		alignSelf: "flex-start",
		minWidth: 180,
		"&:disabled": {
			backgroundColor: "#E0E0E0",
			color: "#A6A6A6"
		}
	}
}))

export default useStyles
